// @ts-nocheck
import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';
import PrimaryButton from '../global/components/ui/buttons/PrimaryButton';
import { t } from '../global/locale';

function VersionUpdateNotification({ isOutdated }) {
    if (!isOutdated) return null;

    return (
        <div className="fx-notification-container">
            <h4 style={{ fontWeight: 600 }}>{t('Ny versjon tilgjengelig')}</h4>
            <p>{t('DxWeb har blitt oppdatert. Last inn siden på nytt for å få siste versjon.')}</p>
            <PrimaryButton text={t('Oppdater nå')} onClick={() => window.location.reload()} />
        </div>
    );
}

VersionUpdateNotification.propTypes = {
    isOutdated: PropTypes.bool.isRequired,
};

export default connect(state => ({
    isOutdated: state.versionStatus.isOutdated,
}))(VersionUpdateNotification);
